/**
 * Нормализация и маска российского телефона.
 * Хранение / API: 7XXXXXXXXXX
 * Отображение: +7 (XXX) XXX-XX-XX
 */

export function phoneDigits(raw) {
  return String(raw || '').replace(/\D/g, '');
}

/**
 * Приводит ввод к 7XXXXXXXXXX.
 * @throws {Error} если номер неполный или неверный
 */
export function normalizePhone(raw) {
  let digits = phoneDigits(raw);
  if (!digits) {
    throw new Error('Введите номер телефона');
  }

  if (digits.length === 11 && digits.startsWith('8')) {
    digits = `7${digits.slice(1)}`;
  } else if (digits.length === 10) {
    digits = `7${digits}`;
  }

  if (digits.length < 11) {
    throw new Error('Номер телефона должен содержать 11 цифр');
  }
  if (digits.length > 11) {
    throw new Error('Номер телефона должен содержать 11 цифр');
  }
  if (!digits.startsWith('7')) {
    throw new Error('Номер телефона должен начинаться с +7');
  }

  return digits;
}

export function isValidPhone(raw) {
  try {
    normalizePhone(raw);
    return true;
  } catch {
    return false;
  }
}

/** Полный номер для UI: +7 (900) 123-45-67 */
export function formatPhoneDisplay(raw) {
  if (!raw) return '';
  try {
    const digits = normalizePhone(raw);
    return `+7 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9, 11)}`;
  } catch {
    return String(raw).trim();
  }
}

/**
 * Маска при вводе: всегда ведёт к +7 (…) …
 * Принимает 8…, 7…, 9… (10 цифр без кода).
 */
export function formatPhoneInput(raw) {
  let digits = phoneDigits(raw);

  if (!digits) {
    return '';
  }

  // 8XXXXXXXXXX → 7…
  if (digits.startsWith('8')) {
    digits = `7${digits.slice(1)}`;
  }

  // Набор без кода страны (начинается с 9…)
  if (!digits.startsWith('7')) {
    digits = `7${digits}`.slice(0, 11);
  } else {
    digits = digits.slice(0, 11);
  }

  const national = digits.slice(1); // до 10 цифр
  let out = '+7';
  if (national.length === 0) {
    return out;
  }

  out += ` (${national.slice(0, Math.min(3, national.length))}`;
  if (national.length < 3) {
    return out;
  }
  out += ')';

  if (national.length > 3) {
    out += ` ${national.slice(3, Math.min(6, national.length))}`;
  }
  if (national.length > 6) {
    out += `-${national.slice(6, Math.min(8, national.length))}`;
  }
  if (national.length > 8) {
    out += `-${national.slice(8, Math.min(10, national.length))}`;
  }
  return out;
}
